export const IMPERSONATION_HINT_COOKIE = 'impersonation'
export const IMPERSONATION_HINT_COOKIE_VALUE = 'active'
export const IMPERSONATION_SESSION_COOKIE = 'impersonation_session'
export const DEFAULT_IMPERSONATION_COOKIE_MAX_AGE = 432000
